import {Environment, Organisation} from '@eitje/api'
import {useFieldValue, useForm} from '@eitje/form'
import {DatePickerField, Input} from '@eitje/web_components'
import {useEffect} from 'react'
import {EitjeButton, LegacyFormModal, Message, Select} from '~/components'
import {goBack} from '~/routing/actions'
import {INSTRUCTIONS_URL} from '../../../firms/constants'

export const SplitOrganisation = () => {
	const environments = Environment.useAll()

	const handleSubmit = async params => {
		const result = await Organisation.create(params)
		if (result.ok) Organisation.index() // necessary to show immediate changes in the table
		return result
	}

	return (
		<LegacyFormModal
			name="split_organisation"
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			modalProps={{
				confirmSubmit: true,
				okButtonProps: {
					t: 'common.create',
					iconLeft: 'checked',
					confirmText: {mdT: ['modals.split_organisation.confirm_message', {INSTRUCTIONS_URL}]},
					confirmButtonProps: {t: 'modals.split_organisation.confirm_button', iconLeft: null},
				},
				buttons: <EitjeButton iconLeft="plus" t="common.environment" modalLink="/firms/environments/new" />,
			}}
			width={400}
		>
			<Message mdT={['modals.split_organisation.message', {INSTRUCTIONS_URL}]} />
			<Input field="name" required />
			<Select field="environment_ids" labelField="naam" formatValue="list" type="multiple" required items={environments} />
			<BillingDatePickerField />
		</LegacyFormModal>
	)
}

const BillingDatePickerField = () => {
	const selectedEnvironmentIds = useFieldValue('environment_ids') || []
	const {setValues} = useForm()
	const firstBillingDates = Organisation.useWhere({environment_ids: selectedEnvironmentIds})._map('first_billing_date')
	const firstBillingDate = firstBillingDates.sort().first()

	useEffect(() => {
		setValues({first_billing_date: firstBillingDate})
	}, [firstBillingDate])

	return <DatePickerField field="first_billing_date" required />
}
